import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData } from "../../../lib/counselorcorner";
import { getIdData as getInstroctorData } from "../../../lib/instructorinfo";
import { getIdData as getStudentData } from "../../../lib/studentinfo";
// import { useAuth } from "../../../usercontext";

export default function GlobalCounselorCorner({ slug, isAdmin }) {
  const [notes, setNotes] = useState([]);
  const [showData, setShowData] = useState(false);
  const [namedNotes, setNamedNotes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const correctPassword = "1234";

  // const { profile } = useAuth();
  // const slug = profile.id;

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      const updatedNotes = notes.filter((note) => note.id !== id);
      setNotes(updatedNotes);
      const updatedNamedNotes = namedNotes.filter((note) => note.id !== id);
      setNamedNotes(updatedNamedNotes);
    }
  };

  async function getIdDataFromDb() {
    const notesfromdb = await getAllData();
    const sortedNotesfromdb = [...notesfromdb].sort((a, b) => a.id - b.id);
    setNamedNotes(sortedNotesfromdb);
  }

  useEffect(() => {
    getIdDataFromDb();
  }, []);

  async function fetchData() {
    const updatedNotes = [];
    for (let note of notes) {
      try {
        const instructor = await getInstroctorData(note.instructorId);
        const student = await getStudentData(note.studentId);
        updatedNotes.push({
          ...note,
          instructorName: instructor[0]?.name || "Unknown Instructor",
          studentName: student[0]?.name || "Unknown Student",
        });
      } catch (error) {
        updatedNotes.push({
          ...note,
          instructorName: "Unknown",
          studentName: "Unknown",
        });
      }
    }
    setNamedNotes(updatedNotes);
  }

  useEffect(() => {
    //fetchData();
  }, [notes]);

  const filteredNotes = namedNotes.filter((data) => {
    const searchData = searchTerm.toLowerCase();
    return (
      data.ndate.toLowerCase().includes(searchData) ||
      data.instructorName.toLowerCase().includes(searchData) ||
      data.studentName.toLowerCase().includes(searchData) ||
      data.note.toLowerCase().includes(searchData)
    );
  });
// ********* PASWORD ***********
  // useEffect(() => {
  //   let timeout;
  //   if (isAuthenticated) {
  //     timeout = setTimeout(() => {
  //       setIsAuthenticated(false);
  //       alert("Session expired. Please enter the password again.");
  //     }, 5 * 60 * 1000); // 5 minutes in milliseconds
  //   }

  //   return () => {
  //     if (timeout) clearTimeout(timeout);
  //   };
  // }, [isAuthenticated]);

  // const handlePasswordSubmit = () => {
  //     if (password === correctPassword) {
  //       setIsAuthenticated(true);
  //     } else {
  //       alert("Incorrect password. Access denied.");
  //     }
  //   };
  //   if (!isAuthenticated) {
  //     return (
  //       <div className="col-xl-12 col-md-12 mx-auto">
  //         <div className="settings-widget profile-details">
  //           <div className="settings-inner-blk p-0">
  //             <div className="profile-heading">
  //               <h3>Conseulor Corner</h3>
  //               <div className="d-flex justify-content-center align-items-center">
  //                 <div
  //                   className="card p-4 shadow-lg"
  //                   style={{ maxWidth: "400px", width: "100%" }}
  //                 >
  //                   <div className="card-body text-center">
  //                     <h5 className="card-subtitle mb-3">
  //                       Enter Password to Access
  //                     </h5>
  //                     <input
  //                       type="password"
  //                       value={password}
  //                       onChange={(e) => setPassword(e.target.value)}
  //                       maxLength="4"
  //                       className="form-control mb-3 text-center"
  //                       placeholder="Enter password"
  //                     />
  //                     <button
  //                       onClick={handlePasswordSubmit}
  //                       className="btn btn-primary w-100"
  //                     >
  //                       Submit
  //                     </button>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  return (
    <div className="col-xl-12 col-md-12 mx-auto">
      {/* <div className="settings-widget profile-details"> */}
        <div className="settings-inner-blk p-2">
          <div className="p-2">
            <div className="d-flex justify-content-between align-items-center">
              <h3>
                {isAdmin === true ? "Admin Private Notes" : "Private Notes"}{" "}
              </h3>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-outline-info"
                  onClick={() => setShowData(!showData)}
                >
                  {showData ? "Hide" : "Show"}
                </button>
                {isAdmin === true ? (
                  <Link
                    to={`/admin/admin-counselorcorneredit/${slug}/Add/0`}
                    className="btn btn-dark btn-dark-1"
                  >
                    Add New Note
                  </Link>
                ) : (
                  <Link
                    to={`/instructor/instructor-counselorcorner-edit/${slug}/Add/0`}
                    className="btn btn-dark btn-dark-1"
                  >
                    Add New Note
                  </Link>
                )}
              </div>
            </div>
          </div>
          {/* <div className="profile-heading">
            <h3>
              {isAdmin === true ? "Admin Private Notes" : "Private Notes"}{" "}
            </h3>
            <div className="new-address">
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-outline-info"
                    onClick={() => setShowData(!showData)}
                  >
                    {showData ? "Hide" : "Show"}
                  </button>
                </div>
                <div className="col"></div>
                <div className="col">
                  {isAdmin === true ? (
                    <Link
                      to={`/admin/admin-counselorcorneredit/${slug}/Add/0`}
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Note
                    </Link>
                  ) : (
                    <Link
                      to={`/instructor/instructor-counselorcorner-edit/${slug}/Add/0`}
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Note
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div> */}

          {/* Search box */}
          {showData && (
            <div className="p-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search in private notes..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          )}

          {showData ? (
            // <div className="comman-space pb-4 card wish-card">
              <div className="card wish-card settings-invoice-blk table-responsive">
                <div className="wishlist-item">
                  {/* Invoice info */}
                  <table
                    className="table table-hover"
                    style={{ width: "100%", tableLayout: "fixed" }}
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Written By</th>
                        <th>Student</th>
                        <th className="w-50 m-4">Note</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredNotes
                        .filter((data) => isAdmin || data.instructorId === slug)
                        .map(function (data) {
                          return (
                            <tr key={data.id}>
                              <td>{data.ndate}</td>
                              <td>{data.instructorName}</td>
                              <td>{data.studentName}</td>
                              <td style={{ paddingRight: "65px" }}>
                                {data.note}
                              </td>
                              <td>
                                <div className="profile-share d-flex align-items-center justify-content-end">
                                  {isAdmin === true ? (
                                    <Link
                                      to={`/admin/admin-counselorcorneredit/${slug}/Update/${data.id}`}
                                      className="btn btn-success btn-sm"
                                    >
                                      Update
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/instructor/instructor-counselorcorner-edit/${slug}/Update/${data.id}`}
                                      className="btn btn-success btn-sm"
                                    >
                                      Update
                                    </Link>
                                  )}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDelete(data.id)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            // </div>
          ) : (
            ""
          )}
        </div>
      {/* </div> */}
    </div>
  );
}
